import React, { useEffect } from 'react'

import { useIntegrationActions } from 'redux/actions/Integrations'
import {
  useIntegrations,
  useIntegrationsFetched
} from 'redux/hooks/Integrations'
import { useTranslation } from 'language/translator'

import ContentBox from 'components_new/molecules/ContentBox'
import GenericListItem from 'components_new/molecules/GenericListItem'

import SettingsTemplate from 'components_new/templates/SettingsTemplate'

const IntegrationsPage = () => {
  const { t } = useTranslation()

  const { tryGetIntegrations } = useIntegrationActions()

  const integrations = useIntegrations()
  const fetched = useIntegrationsFetched()

  useEffect(() => {
    if (!fetched) {
      tryGetIntegrations()
    }
  }, [])

  return (
    <SettingsTemplate>
      <ContentBox border={true} disablePadding={true}>
        {integrations.map((integration) => (
          <GenericListItem
            action="to"
            body={
              integration.key === 'fortnox'
                ? t('integrations', 'fortnox_page_body')
                : undefined
            }
            key={integration.key}
            src={integration.logoURL ?? undefined}
            icon={
              integration.logoURL ? undefined : { name: 'ApiOutlined' as const }
            }
            title={integration.name}
            to={`/settings/integrations/${integration.key}`}
          />
        ))}
      </ContentBox>
    </SettingsTemplate>
  )
}

export default IntegrationsPage
